import {
  logout,
  registerByWechatMiniProgram,
  loginByWechatMiniProgram,
  hasLogined,
  registerByNameAndPassword,
  registerByMobilePhoneNum,
  registerByWechatServiceAccount,
  updatePhoneNumberByWechatMiniProgram,
  registerByWechatMiniProgramNoPhoneNum,
  registerByWechatWebApp,
  registerByWechatMobileApp,
  loginByNameAndPassword,
  loginByMobilePhoneNum,
  loginByWechatServiceAccount,
  registerAndloginByWechatMiniProgram,
  loginByWebApp,
  loginByMobileApp,
  getSelfInfo,
  modifyPassword,
  modifyPasswordBySMS,
  modifySelfInfo,
  getWebVerifyCode,
  checkMobileVerifyCode,
  checkWebVerifyCode
} from '@/api/accountserv'

export default {
  state: {
    state_Account_LogoutResult: null,
    state_Account_RegisterByWechatMiniProgramResult: null,
    state_Account_LoginByWechatMiniProgramResult: null,
    state_Account_HasLoginedResult: null,
    state_Account_RegisterByNameAndPasswordResult: null,
    state_Account_RegisterByMobilePhoneNumResult: null,
    state_Account_RegisterByWechatServiceAccountResult: null,
    state_Account_UpdatePhoneNumberByWechatMiniProgramResult: null,
    state_Account_RegisterByWechatMiniProgramNoPhoneNumResult: null,
    state_Account_RegisterByWechatWebAppResult: null,
    state_Account_RegisterByWechatMobileAppResult: null,
    state_Account_LoginByNameAndPasswordResult: null,
    state_Account_LoginByMobilePhoneNumResult: null,
    state_Account_LoginByWechatServiceAccountResult: null,
    state_Account_RegisterAndloginByWechatMiniProgramResult: null,
    state_Account_LoginByWebAppResult: null,
    state_Account_LoginByMobileAppResult: null,
    state_Account_GetSelfInfoResult: null,
    state_Account_ModifyPasswordResult: null,
    state_Account_ModifyPasswordBySMSResult: null,
    state_Account_ModifySelfInfoResult: null,
    state_Account_GetWebVerifyCodeResult: null,
    state_Account_CheckMobileVerifyCodeResult: null,
    state_Account_CheckWebVerifyCodeResult: null
  },
  mutations: {
    SET_ACCOUNT_LOGOUT_RESULT: (state, rst) => {
      state.state_Account_LogoutResult = rst
    },
    SET_ACCOUNT_REGISTERBYWECHATMINIPROGRAM_RESULT: (state, rst) => {
      state.state_Account_RegisterByWechatMiniProgramResult = rst
    },
    SET_ACCOUNT_LOGINBYWECHATMINIPROGRAM_RESULT: (state, rst) => {
      state.state_Account_LoginByWechatMiniProgramResult = rst
    },
    SET_ACCOUNT_HASLOGINED_RESULT: (state, rst) => {
      state.state_Account_HasLoginedResult = rst
    },
    SET_ACCOUNT_REGISTERBYNAMEANDPASSWORD_RESULT: (state, rst) => {
      state.state_Account_RegisterByNameAndPasswordResult = rst
    },
    SET_ACCOUNT_REGISTERBYMOBILEPHONENUM_RESULT: (state, rst) => {
      state.state_Account_RegisterByMobilePhoneNumResult = rst
    },
    SET_ACCOUNT_REGISTERBYWECHATSERVICEACCOUNT_RESULT: (state, rst) => {
      state.state_Account_RegisterByWechatServiceAccountResult = rst
    },
    SET_ACCOUNT_UPDATEPHONENUMBERBYWECHATMINIPROGRAM_RESULT: (state, rst) => {
      state.state_Account_UpdatePhoneNumberByWechatMiniProgramResult = rst
    },
    SET_ACCOUNT_REGISTERBYWECHATMINIPROGRAMNOPHONENUM_RESULT: (state, rst) => {
      state.state_Account_RegisterByWechatMiniProgramNoPhoneNumResult = rst
    },
    SET_ACCOUNT_REGISTERBYWECHATWEBAPP_RESULT: (state, rst) => {
      state.state_Account_RegisterByWechatWebAppResult = rst
    },
    SET_ACCOUNT_REGISTERBYWECHATMOBILEAPP_RESULT: (state, rst) => {
      state.state_Account_RegisterByWechatMobileAppResult = rst
    },
    SET_ACCOUNT_LOGINBYNAMEANDPASSWORD_RESULT: (state, rst) => {
      state.state_Account_LoginByNameAndPasswordResult = rst
    },
    SET_ACCOUNT_LOGINBYMOBILEPHONENUM_RESULT: (state, rst) => {
      state.state_Account_LoginByMobilePhoneNumResult = rst
    },
    SET_ACCOUNT_LOGINBYWECHATSERVICEACCOUNT_RESULT: (state, rst) => {
      state.state_Account_LoginByWechatServiceAccountResult = rst
    },
    SET_ACCOUNT_REGISTERANDLOGINBYWECHATMINIPROGRAM_RESULT: (state, rst) => {
      state.state_Account_RegisterAndloginByWechatMiniProgramResult = rst
    },
    SET_ACCOUNT_LOGINBYWEBAPP_RESULT: (state, rst) => {
      state.state_Account_LoginByWebAppResult = rst
    },
    SET_ACCOUNT_LOGINBYMOBILEAPP_RESULT: (state, rst) => {
      state.state_Account_LoginByMobileAppResult = rst
    },
    SET_ACCOUNT_GETSELFINFO_RESULT: (state, rst) => {
      state.state_Account_GetSelfInfoResult = rst
    },
    SET_ACCOUNT_MODIFYPASSWORD_RESULT: (state, rst) => {
      state.state_Account_ModifyPasswordResult = rst
    },
    SET_ACCOUNT_MODIFYPASSWORDBYSMS_RESULT: (state, rst) => {
      state.state_Account_ModifyPasswordBySMSResult = rst
    },
    SET_ACCOUNT_MODIFYSELFINFO_RESULT: (state, rst) => {
      state.state_Account_ModifySelfInfoResult = rst
    },
    SET_ACCOUNT_GETWEBVERIFYCODE_RESULT: (state, rst) => {
      state.state_Account_GetWebVerifyCodeResult = rst
    },
    SET_ACCOUNT_CHECKMOBILEVERIFYCODE_RESULT: (state, rst) => {
      state.state_Account_CheckMobileVerifyCodeResult = rst
    },
    SET_ACCOUNT_CHECKWEBVERIFYCODE_RESULT: (state, rst) => {
      state.state_Account_CheckWebVerifyCodeResult = rst
    }
  },
  actions: {
    AccountServ_Logout ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        logout(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGOUT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGOUT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByWechatMiniProgram ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByWechatMiniProgram(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYWECHATMINIPROGRAM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYWECHATMINIPROGRAM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_LoginByWechatMiniProgram ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        loginByWechatMiniProgram(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGINBYWECHATMINIPROGRAM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGINBYWECHATMINIPROGRAM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_HasLogined ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        hasLogined(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_HASLOGINED_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_HASLOGINED_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByNameAndPassword ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByNameAndPassword(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYNAMEANDPASSWORD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYNAMEANDPASSWORD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByMobilePhoneNum ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByMobilePhoneNum(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYMOBILEPHONENUM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYMOBILEPHONENUM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByWechatServiceAccount ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByWechatServiceAccount(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYWECHATSERVICEACCOUNT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYWECHATSERVICEACCOUNT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_UpdatePhoneNumberByWechatMiniProgram ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        updatePhoneNumberByWechatMiniProgram(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_UPDATEPHONENUMBERBYWECHATMINIPROGRAM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_UPDATEPHONENUMBERBYWECHATMINIPROGRAM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByWechatMiniProgramNoPhoneNum ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByWechatMiniProgramNoPhoneNum(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYWECHATMINIPROGRAMNOPHONENUM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYWECHATMINIPROGRAMNOPHONENUM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByWechatWebApp ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByWechatWebApp(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYWECHATWEBAPP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYWECHATWEBAPP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterByWechatMobileApp ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerByWechatMobileApp(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERBYWECHATMOBILEAPP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERBYWECHATMOBILEAPP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_LoginByNameAndPassword ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        loginByNameAndPassword(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGINBYNAMEANDPASSWORD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGINBYNAMEANDPASSWORD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_LoginByMobilePhoneNum ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        loginByMobilePhoneNum(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGINBYMOBILEPHONENUM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGINBYMOBILEPHONENUM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_LoginByWechatServiceAccount ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        loginByWechatServiceAccount(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGINBYWECHATSERVICEACCOUNT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGINBYWECHATSERVICEACCOUNT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_RegisterAndloginByWechatMiniProgram ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        registerAndloginByWechatMiniProgram(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_REGISTERANDLOGINBYWECHATMINIPROGRAM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_REGISTERANDLOGINBYWECHATMINIPROGRAM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_LoginByWebApp ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        loginByWebApp(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGINBYWEBAPP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGINBYWEBAPP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_LoginByMobileApp ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        loginByMobileApp(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_LOGINBYMOBILEAPP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_LOGINBYMOBILEAPP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_GetSelfInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getSelfInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_GETSELFINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_GETSELFINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_ModifyPassword ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyPassword(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_MODIFYPASSWORD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_MODIFYPASSWORD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_ModifyPasswordBySMS ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyPasswordBySMS(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_MODIFYPASSWORDBYSMS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_MODIFYPASSWORDBYSMS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_ModifySelfInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifySelfInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_MODIFYSELFINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_MODIFYSELFINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_GetWebVerifyCode ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getWebVerifyCode(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_GETWEBVERIFYCODE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_GETWEBVERIFYCODE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_CheckMobileVerifyCode ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        checkMobileVerifyCode(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_CHECKMOBILEVERIFYCODE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_CHECKMOBILEVERIFYCODE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AccountServ_CheckWebVerifyCode ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        checkWebVerifyCode(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ACCOUNT_CHECKWEBVERIFYCODE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ACCOUNT_CHECKWEBVERIFYCODE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Account_LogoutResult: state => {
      return state.state_Account_LogoutResult
    },
    get_Account_RegisterByWechatMiniProgramResult: state => {
      return state.state_Account_RegisterByWechatMiniProgramResult
    },
    get_Account_LoginByWechatMiniProgramResult: state => {
      return state.state_Account_LoginByWechatMiniProgramResult
    },
    get_Account_HasLoginedResult: state => {
      return state.state_Account_HasLoginedResult
    },
    get_Account_RegisterByNameAndPasswordResult: state => {
      return state.state_Account_RegisterByNameAndPasswordResult
    },
    get_Account_RegisterByMobilePhoneNumResult: state => {
      return state.state_Account_RegisterByMobilePhoneNumResult
    },
    get_Account_RegisterByWechatServiceAccountResult: state => {
      return state.state_Account_RegisterByWechatServiceAccountResult
    },
    get_Account_UpdatePhoneNumberByWechatMiniProgramResult: state => {
      return state.state_Account_UpdatePhoneNumberByWechatMiniProgramResult
    },
    get_Account_RegisterByWechatMiniProgramNoPhoneNumResult: state => {
      return state.state_Account_RegisterByWechatMiniProgramNoPhoneNumResult
    },
    get_Account_RegisterByWechatWebAppResult: state => {
      return state.state_Account_RegisterByWechatWebAppResult
    },
    get_Account_RegisterByWechatMobileAppResult: state => {
      return state.state_Account_RegisterByWechatMobileAppResult
    },
    get_Account_LoginByNameAndPasswordResult: state => {
      return state.state_Account_LoginByNameAndPasswordResult
    },
    get_Account_LoginByMobilePhoneNumResult: state => {
      return state.state_Account_LoginByMobilePhoneNumResult
    },
    get_Account_LoginByWechatServiceAccountResult: state => {
      return state.state_Account_LoginByWechatServiceAccountResult
    },
    get_Account_RegisterAndloginByWechatMiniProgramResult: state => {
      return state.state_Account_RegisterAndloginByWechatMiniProgramResult
    },
    get_Account_LoginByWebAppResult: state => {
      return state.state_Account_LoginByWebAppResult
    },
    get_Account_LoginByMobileAppResult: state => {
      return state.state_Account_LoginByMobileAppResult
    },
    get_Account_GetSelfInfoResult: state => {
      return state.state_Account_GetSelfInfoResult
    },
    get_Account_ModifyPasswordResult: state => {
      return state.state_Account_ModifyPasswordResult
    },
    get_Account_ModifyPasswordBySMSResult: state => {
      return state.state_Account_ModifyPasswordBySMSResult
    },
    get_Account_ModifySelfInfoResult: state => {
      return state.state_Account_ModifySelfInfoResult
    },
    get_Account_GetWebVerifyCodeResult: state => {
      return state.state_Account_GetWebVerifyCodeResult
    },
    get_Account_CheckMobileVerifyCodeResult: state => {
      return state.state_Account_CheckMobileVerifyCodeResult
    },
    get_Account_CheckWebVerifyCodeResult: state => {
      return state.state_Account_CheckWebVerifyCodeResult
    }
  }
}
